/**
 * @Author: Lihao sun sunlihao.cosmo@haier.com
 * @Date: 2024-12-19 09:59:56
 * @LastEditors: Lihao sun sunlihao.cosmo@haier.com
 * @LastEditTime: 2025-01-15 18:50:08
 * @FilePath: src/api/user.js
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 */
/**
 * @Author 22030124/xieyq
 * @Date 2023-11-20 17:11:52
 * @Description 请求接口 =》用户相关接口js
 */
import request from '@/utils/request'
import axios from 'axios'

// 获取iam的登录地址
export function getIAMLoginUrl() {
  return request({
    url: '/base/user/toLogin',
    method: 'get'
  })
}

export function getLoginUrl(pageUrl) {
  // const url = `/base/user/authorizeLogin?pageUrl=${pageUrl}`
  // console.log(url)
  return request({
    url: `/base/user/authorizeLogin?pageUrl=${pageUrl}`,
    method: 'get'
  })
}
export function refreshTokenApi(refreshToken) {
  return request({
    url: `/base/user/refreshToken?refreshToken=${refreshToken}`,
    method: 'get'
  })
}

// 用户退出登录
export function logout(params) {
  return request({
    url: `/base/user/logout`,
    method: 'post',
    params
  })
}
// 获取应用详情
export function getAppData(id) {
  return request({
    url: `/base/app/${id}`,
    method: 'get'
  })
}
// 获取当前登录的用户的信息
export function getInfo(params) {
  return request({
    url: `/base/user/getUserInfo`,
    method: 'get',
    params
  })
}

export function submitEnterpriseInfo(data) {
  return request({
    url: '/base/user/enterpriseInfo/submit',
    method: 'post',
    data
  })
}

export function getTenantList(params) {
  return request({
    url: `/base/tenant/getPageListUserTenant`,
    method: 'get',
    params
  })
}
export function changeCurrentTenant (tenantId) {
  return request({
    url: `/base/tenant/switchCurrentTenant?tenantId=${tenantId}`,
    method: 'get'
  })
}
export function getIndustryLabelList() {
  return request({
    url: `/base/tenant/getIndustryLableList`,
    method: 'get'
  })
}
export function completeGuild() {
  return request({
    url: `/base/user/completeGuild`,
    method: 'post'
  })
}
export function completeWorkbenchGuide() {
  return request({
    url: `/base/user/completeWorkbenchGuide`,
    method: 'post'
  })
}

// 校验当前登录的用户的token
export function validateToken(params) {
  return request({
    url: `/base/user/checkToken`,
    method: 'get',
    params
  })
}
// 校验当前登录的用户是否超管
export function isAdmin() {
  return request({
    url: `/base/user/isAdmin`,
    method: 'get'
  })
}
// 校验当前登录的用户是否超管
export function getApplyUrl() {
  return request({
    url: `/base/app/apply/url`,
    method: 'get'
  })
}

/**
 * 请求用户信息
 * @param {String} userCode 工号
 * @returns {Promise}
 */
export function requestIHaierUserInfo(userCode) {
  return axios({
    // 请求地址
    url: `https://gateway.cosmoplat.com/SV000001/getUser`,
    // 请求头
    headers: {
      'Content-Type': 'application/json'
    },
    // 请求方法
    method: 'GET',
    params: {
      // 申请的访问凭证(key)
      key: 'qvg3uab8k4gwdv6zs54v6o3z6d8zjjil',
      // 工号
      empNo: userCode
    }
  })
}
